import { QueryKeys } from "../../utils/queryKeys";

export const finalAssessmentQuestionKeys = {
  all: [QueryKeys.FINAL_ASSESSMENT_QUESTION],

  getFinalAssessmentQuestionKeys: (args) => {
    const { userId } = args;

    return [...finalAssessmentQuestionKeys.all, userId];
  },
};
